/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorCreationItemDetails } from './monitorCreationItemDetails';


export interface MonitorCreationItem { 
    deployment_id?: string;
    org_id?: string;
    details?: MonitorCreationItemDetails | null;
}

